import React, { useContext, useEffect, useState } from "react";
import { View, SafeAreaView, Linking, TouchableOpacity } from "react-native";
import styled from "styled-components/native";
import _ from "lodash";
import moment from "moment";

import {
  FlexBlockWrapped,
  ShinyBlockOuter,
  ShinyHeading,
  ShinyBody,
  MetricStackTitle,
  BasicText as Text,
  Heading3,
  Heading2,
  Heading4,
  FlexElement,
  ExtraStyles,
  BasicText,
  PageWrapper,
} from "../Styles";
import { Tabular, TabularColumn } from "../core/Tabular";
import { YOUTUBE, LINKEDIN, FACEBOOK } from "../../assets";
import SupportView from "./SupportView";
import Modal from "../core/Modal";
import Icon from "../core/Icon";
import ServiceRequest from "../Site/View/ServiceRequest";
import Util from "../core/Util";
import { PortalDataContext } from "../PortalContext";

const InfoBlock = styled.View`
  flex-direction: row;
  align-items: center;
  min-width: 230px;
  justify-content: ${(props) =>
    props.justify != undefined ? props.justify : null};
`;

const PersonBlock = styled.View``;

const InfoContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 10px;
`;

const ImageWrapper = styled.TouchableOpacity`
  padding-bottom: 5px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: ${(props) => (props.size ? props.size + 10 + "px" : "70px")};
  height: ${(props) => (props.size ? props.size + 10 + "px" : "70px")};
`;

const StyledImage = styled.Image`
  width: ${(props) => (props.size ? props.size + "px" : "60px")};
  height: ${(props) => (props.size ? props.size + "px" : "60px")};
`;

const ImageBlock = ({
  source,
  size = 60,
  onPressEvent = undefined,
  style = {},
}) => {
  return (
    <ImageWrapper activeOpacity={1} onPress={onPressEvent} size={size}>
      <StyledImage
        source={{ uri: source != undefined ? source : null }}
        size={size}
        style={style}
      />
    </ImageWrapper>
  );
};

const Person = ({ personData }) => {
  return (
    <InfoBlock justify={personData.avatar != undefined ? null : "center"}>
      {personData.avatar != undefined ? (
        <ImageBlock
          source={Util.getHost() + personData.avatar}
          style={{ borderRadius: 5, cursor: "arrow" }}
        />
      ) : null}
      <PersonBlock>
        <Heading4>{personData.position}</Heading4>
        {personData.lastName != undefined ? (
          <Text>
            {personData.firstName} {personData.lastName}
          </Text>
        ) : null}
        <Text>{personData.phoneNumber}</Text>
        <Text>{personData.email}</Text>
      </PersonBlock>
    </InfoBlock>
  );
};

const ContactBlock = ({ contacts = [], openModal }) => {
  const openServiceRequest = () => {
    openModal(<ServiceRequest />);
  };

  return (
    <ShinyBlockOuter flexBasis="99%">
      <ShinyBody>
        <View>
          <Heading2>Waste Solutions is here to help</Heading2>
          <Text>Contact our 24/7 Live Customer Service</Text>
        </View>
        <InfoContainer>
          {_.map(contacts, (c) => (
            <Person personData={c} key={c.id} />
          ))}
          <View>
            <Heading4>Social Media</Heading4>
            <InfoBlock>
              <ImageBlock
                source={YOUTUBE}
                size={30}
                style={{ overflow: "visible" }}
                onPressEvent={() =>
                  Linking.openURL(
                    "https://www.youtube.com/channel/UCbBGnl_hGlb5jf7isbiF_kw"
                  )
                }
              />
              <ImageBlock
                source={LINKEDIN}
                size={30}
                style={{ overflow: "visible" }}
                onPressEvent={() =>
                  Linking.openURL(
                    "https://www.linkedin.com/company/waste-solutions-canada/?trk=tyah&trkInfo=tarId%3A1415119960739%2Ctas%3Awaste+solutions+ca%2Cidx%3A2-2-3"
                  )
                }
              />
              <ImageBlock
                source={FACEBOOK}
                size={30}
                style={{ overflow: "visible" }}
                onPressEvent={() =>
                  Linking.openURL(
                    "https://www.facebook.com/Waste-Solutions-Canada-664573086886868/"
                  )
                }
              />
            </InfoBlock>
          </View>
        </InfoContainer>
        <View style={{ flexDirection: "row", justifyContent: "center" }}>
          <TouchableOpacity
            onPress={openServiceRequest}
            style={[
              ExtraStyles.buttonLight,
              ExtraStyles.blueButton,
              { width: "215px" },
            ]}
          >
            <Icon icon="dumpster" />
            <Text>Request Extra Pickup</Text>
            <Icon icon="long-arrow-right" size={15} />
          </TouchableOpacity>
        </View>
      </ShinyBody>
    </ShinyBlockOuter>
  );
};

const Tickets = ({ tickets = [], openModal }) => {
  const openTicket = (ticket) => {
    openModal(<SupportView ticket={ticket} />);
  };

  return (
    <ShinyBlockOuter flexBasis="99%">
      <ShinyHeading>
        <MetricStackTitle>My Requests</MetricStackTitle>
      </ShinyHeading>
      <ShinyBody>
        <Tabular data={tickets} onClick={(ticket) => openTicket(ticket)}>
          <TabularColumn
            title="Site"
            data={(row) => (row.site != undefined ? row.site.name : "")}
          />
          <TabularColumn
            title="Type"
            data={(row) =>
              row.taskTypeObject != undefined ? row.taskTypeObject.name : ""
            }
          />
          <TabularColumn
            title="Description"
            data={(row) => row.shortDescription}
          />
          <TabularColumn
            title="Date Sent"
            data={(row) => moment(row.created).format("YYYY-MM-DD HH:mm")}
          />
          <TabularColumn title="Status" data={(row) => row.status} />
        </Tabular>
      </ShinyBody>
    </ShinyBlockOuter>
  );
};

const Dashboard = ({ portalData }) => {
  const portalDataContext = useContext(PortalDataContext);
  const [supportData, setSupportData] = useState({ contacts: [], tickets: [] });
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    if (modalVisible == false) {
      setModalContent(null);
    }
  }, [modalVisible]);

  useEffect(() => {
    if (portalDataContext.authToken != undefined) {
      fetch(
        Util.getHost() +
          "/api/v1/portal/fetchSupportTickets?authToken=" +
          portalDataContext.authToken.code,
        { headers: { portalUI: "yes" } } //portalUI header used in backend api authentication
      )
        .then((r) => r.json())
        .then((result) => {
          setSupportData(result);
        });
    }
  }, [portalData]);

  const openModal = (content) => {
    setModalContent(content);
    setModalVisible(true);
  };

  return (
    <PageWrapper>
      <Modal modalVisible={modalVisible} setModalVisible={setModalVisible}>
        {modalContent}
      </Modal>
      <ContactBlock
        contacts={supportData.contacts}
        openModal={(content) => openModal(content)}
      />
      <Tickets
        tickets={supportData.tickets}
        openModal={(content) => openModal(content)}
      />
    </PageWrapper>
  );
};

export default Dashboard;
